import {Pipe, PipeTransform} from "@angular/core";
import {StranaZustatku, TypUctu} from "../enums/enums";


@Pipe({
    name: 'fromStringToEnum',
    standalone: false
})
export class FromStringToEnumPipe implements PipeTransform {
  transform(value: string, ...args: any[]) {
    switch(args[0]){
      case 0:
        return this.findMatchingEnumIndexes(TypUctu, value);
      case 1:
        return this.findMatchingEnumIndexes(StranaZustatku, value);
    }
    return "";
  }

  findMatchingEnumIndexes<T extends Record<string, string | number>>(
    enumObj: T,
    search: string
  ): number[] {
    const values = Object.values(enumObj);
    return values.reduce((indexes: number[], value, index) => {
      if (typeof value === 'string' && value.toLowerCase().includes(search.toLowerCase())) {
        indexes.push(index);
      }
      return indexes;
    }, []);
  }

}
